import { render, staticRenderFns } from "./sh.vue?vue&type=template&id=1ca9da2f&scoped=true&"
import script from "./sh.vue?vue&type=script&lang=js&"
export * from "./sh.vue?vue&type=script&lang=js&"
import style0 from "./sh.vue?vue&type=style&index=0&id=1ca9da2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca9da2f",
  null
  
)

export default component.exports